<template>
  <div class="banner">
    <!-- 右侧图片 -->
    <div class="b-r">
      <img src="/imgs/b2.jpg" alt="" />
      <img src="/imgs/b3.jpg" alt="" />
    </div>

    <!-- 左侧banenr -->
    <div class="b-banner">
      <img src="/imgs/b1.jpg" />
      <!-- <p>中国家庭关系一定跟权力有关，爱却不一定</p> -->
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
@import "./../assets/scss/base.scss";
@import "./../assets/scss/config.scss";
@import "./../assets/scss/mixin.scss";
.banner {
  width: 100%;
  height: 400px;
  // background: pink;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 40px;
  .b-banner {
    width: 70%;
    height: 100%;
    // background-color: #c60023;
    position: relative;
    img {
      width: 100%;
      height: 100%;
    }
    p {
      width: 100%;
      height: 40px;
      background-color: rgba(0, 0, 0, 0.3);
      position: absolute;
      left: 0;
      bottom: 0;
      font-size: 12px;
      font-weight: bold;
      text-align: center;
      line-height: 40px;
      border-top: 2px solid #ccc;
      color: #fff;
    }
  }
  .b-r {
    width: 30%;
    margin-right: 20px;
    height: 100%;
    // background-color: #ff6600;
    img {
      width: 100%;
      height: 50%;
    }
  }
}
</style>